import { motion } from 'framer-motion'

const toAltText = (name: string | undefined) => {
  if (!name) return 'Decorative illustration'
  const formatted = name
    .toString()
    .replace(/[-_]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

  if (!formatted) return 'Decorative illustration'

  return `${formatted.charAt(0).toUpperCase()}${formatted.slice(1)} illustration`
}

interface IllustrationProps {
  name: string;
  className?: string;
  animate?: boolean;
  alt?: string;
}

export default function Illustration({ name, className = '', animate = false, alt }: IllustrationProps) {
  const altText = alt ?? toAltText(name)

  const img = (
    <img
      src={`/illustrations/${name}.svg`}
      alt={altText}
      className={className}
      loading="lazy"
    />
  )

  if (!animate) {
    return img
  }

  return (
    <motion.div animate={{ y: [-4, 0, -4] }} transition={{ duration: 4, repeat: Infinity, ease: 'easeInOut' }}>
      {img}
    </motion.div>
  )
}
